import { render, staticRenderFns } from "./PlanReaccionCorreoOtro.vue?vue&type=template&id=3896169c&"
import script from "./PlanReaccionCorreoOtro.vue?vue&type=script&lang=js&"
export * from "./PlanReaccionCorreoOtro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports